export class Env {
  private static instance: Env;
  baseUrl = import.meta.env.VITE_BASE_URL;
  brandCollaborationClientUrl = import.meta.env
    .VITE_BRAND_COLLABORATION_CLIENT_URL;
  sentryDsn = import.meta.env.VITE_SENTRY_DSN;

  private constructor() {}

  static getInstance(): Env {
    if (!Env.instance) {
      Env.instance = new Env();
    }
    return Env.instance;
  }
}
